import { ModalWrapper } from "../../utils/fw"
import { RoundTables } from "../components/Roundtables"


export default {
	background: "https://assets.swoogo.com/uploads/full/1411163-6168a25198f3c.jpg",
	extras: <RoundTables numTables={4} seatsPerTable={8} dataSource="https://isf2021db.swoogo-retrofit.tkevents.io" />,
	links: [
		{
			label: "Agenda",
			href: "https://isfcongress.tkeventsregistration.com/digital2021/roundtablesaschedule",
			isExternal: true,
			target: "_blank",
			width: "15.7%",
			height: "8.7%",
			left: "1.9%",
			top: "6.5%",
		},
		{
			height: "8.7%",
			left: "82.4%",
			modal: <ModalWrapper dismissStyle={{ right: "2vw", top: "2vw" }}>
				<div style={{ color: "white", maxWidth: "50vw", padding: "1vw" }}>
					<h1>ROUNDTABLE SESSIONS INSTRUCTIONS</h1>
					<p>To join a discussion, click on a table. You will then automatically join a Video Meeting in the centre screen.</p>
					<p>If you’d like to switch to another table, simply click on the table you’d like to join, and you will automatically join the relevant meeting.</p>
					<p>All seats at the tables will populate with each individual currently participating in the discussion. You can click on a headshot to view who the individual is, as well as click to chat with them.</p>
					<p>There are no maximum capacities. If a table appears to be full, you can still join.</p>
				</div>
			</ModalWrapper>,
			top: "6.5%",
			width: "15.7%",
		}],
	name: "roundtables",
}
